import EmailVerified from "./email-verified.container";

export default EmailVerified;